import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { Nav, NavItem } from 'react-bootstrap';
import { LinkContainer } from 'react-router-bootstrap';

import searchOptions from './searchOptions';
import './DesktopNav.css';

class DesktopNav extends Component {
  isCurrentPath(linkPath) {
    return linkPath === this.props.currentPath;
  }

  render() {
    return (
      <Nav bsStyle="tabs" className="DesktopNav">
        {searchOptions.map(searchOption => {
          const linkPath = this.props.basePath + searchOption.path;
          return (
            <LinkContainer key={linkPath} to={linkPath} exact >
              <NavItem disabled={this.isCurrentPath(linkPath)}>
                {searchOption.title}
              </NavItem>
            </LinkContainer>
          );
        })}
      </Nav>
    );
  }
}

DesktopNav.propTypes = {
  basePath: PropTypes.string.isRequired,
  currentPath: PropTypes.string.isRequired,
};

export default DesktopNav;



// WEBPACK FOOTER //
// ./src/components/search/searchNav/DesktopNav.js